export enum DocumentKeyEnum {
  CASHOUT = 'CASHOUT', // Расходный кассовый ордер
  BUYER_RETURN = 'BUYER_RETURN', // Возврат товаров от покупателя
  INCOMING_CASH = 'INCOMING_CASH', // Приходный кассовый ордер
  OUTGOING = 'OUTGOING', // Списание с расчетного счета
  PAYMENT = 'PAYMENT', // Поступление на расчетный счет
  RECEIPT = 'RECEIPT', // Поступление товаров и услуг
  SALE = 'SALE', // Реализация товаров и услуг
  SUPPLIER_RETURN = 'SUPPLIER_RETURN', // Возврат товаров поставщику
  MANUAL = 'MANUAL', // Ручной тип документов, созданный пользователем
  SALE_CORRECTION = 'SALE_CORRECTION', // Корректировка реализации
}
